module.exports = __webpack_public_path__ + "img/benoit28.f2810ff1.jpg";